import { SidebarMenu as Menu } from 'module/ui/components/atoms/dropdown/menu';
import { SearchInputExpanded } from 'module/ui/components/atoms/input/search-input-expanded';
import { FilterBar } from 'module/ui/components/molecules/filter-bar';
import { Short01, SingleLineEllipsis } from 'module/ui/components/styles';
import { Layout } from 'module/ui/components/templates/argon/components';
import styled from 'styled-components';

export const LoadingWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const Sidebar = styled(Layout.Sider)`
  flex: 0 0 294px !important;
  max-width: 294px !important;
  min-width: 294px !important;
  width: 294px !important;
  height: 100% !important;
  overflow: hidden !important;
  overflow-y: auto !important;
  background: var(--white-100);
  padding: var(--spacing-05);
  border-right: 1px solid var(--field-border-default);
  ${SearchInputExpanded} {
    margin-bottom: var(--spacing-05);
  }
`;
export const SidebarInPopover = styled(Sidebar)`
  height: 70vh !important;
`;

export const PageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

export const Title = styled.div`
  ${Short01};
  color: var(--text-primary);
  ${SingleLineEllipsis};
`;

export const SecondaryFilter = styled(FilterBar.Secondary)`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

export const MainContent = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  width: 100%;

  ${FilterBar} {
    flex-shrink: 0;
    box-shadow: none;
  }
`;
export const PageContent = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;
export const SidebarMenu = styled(Menu)`
  .ant-menu-item {
    height: 48px;
  }
`;
